import { Component } from '@angular/core';

@Component({
  selector: 'allas-porque-usar-la-app',
  imports: [],
  template: `
    <section class="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6">
      <!-- Versión móvil -->
      <article
        class="xl:hidden grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[220px] p-4"
        style="background-image: url('/images/services/aplicacion-movil/recibe-cotizacion-rapida-mobile.webp')"
      >
        <div class="col-span-6 flex flex-col gap-2 items-center justify-center">
          <h3 class="text-lg font-medium fs-condensed">
            Recibe una Cotización Rápida y Precisa
          </h3>
          <p class="text-xs fs-condensed">
            Si selecionas tu lista de repuestos que necesitas desde tu App y la
            envias desde la mismas, Garantizamos enviarte una cotización más
            exacta de los repuestos que necesitas, y lo haremos de una forma mas
            expedita.
          </p>
        </div>
      </article>
      <!-- Versión desktop -->
      <article
        class="hidden xl:grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[470px] xl:p-16"
        style="background-image: url('/images/services/aplicacion-movil/recibe-cotizacion-rapida.webp')"
      >
        <div class="col-span-6 flex flex-col gap-2 items-center justify-center">
          <h2 class="text-lg xl:text-4xl font-medium fs-condensed">
            Recibe una Cotización Rápida y Precisa
          </h2>
          <p class="text-sm xl:text-lg fs-condensed">
            Si selecionas tu lista de repuestos que necesitas desde tu App y la
            envias desde la mismas, Garantizamos enviarte una cotización más
            exacta de los repuestos que necesitas, y lo haremos de una forma mas
            expedita.
          </p>
        </div>
      </article>
      <!-- Versión móvil -->
      <article
        class="xl:hidden grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[250px] p-4"
        style="background-image: url('/images/services/aplicacion-movil/escanea-vin-mobile.webp')"
      >
        <div
          class="col-start-7 col-end-13 flex flex-col gap-2 items-center justify-start"
        >
          <h3 class="text-xl font-medium text-white fs-condensed">
            Escanea VIN/Codigo de Barra
          </h3>
          <p class="text-xs text-white font-light fs-condensed">
            Puedes seleccionar tu vehiculo mas facil, rapido y exacto escaneado
            el VIN del mismo. Puedes escanear el codigo de barra de nuestros
            productos.
          </p>
        </div>
      </article>
      <!-- Versión desktop -->
      <article
        class="hidden xl:grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[470px] xl:p-4"
        style="background-image: url('/images/services/aplicacion-movil/escanea-vin.webp')"
      >
        <div
          class="col-start-9 col-end-13 flex flex-col gap-2 items-center justify-start xl:mt-6"
        >
          <h2 class="text-lg xl:text-3xl font-medium text-white fs-condensed">
            Escanea VIN/Codigo de Barra
          </h2>
          <p class="text-sm xl:text-lg text-white font-light fs-condensed">
            Puedes seleccionar tu vehiculo mas facil, rapido y exacto escaneado
            el VIN del mismo. Puedes escanear el codigo de barra de nuestros
            productos. para obtener mas información.
          </p>
        </div>
      </article>
      <!-- Versión móvil -->
      <article
        class="xl:hidden grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[220px] p-4"
        style="background-image: url('/images/services/aplicacion-movil/compra-en-linea-mobile.webp')"
      >
        <div class="col-start-8 col-end-13 flex flex-col gap-2 justify-center">
          <h3 class="text-xl font-medium fs-condensed">Compra en Línea</h3>
          <p class="text-xs fs-condensed">
            Puedes agregar tus cotizaciones y comprar en linea desde esta
            opción. Pagar y recoger en tienda o a domicilio.
          </p>
        </div>
      </article>
      <!-- Versión desktop -->
      <article
        class="hidden xl:grid grid-cols-12 gap-2 bg-cover bg-center bg-no-repeat h-[470px] xl:p-16"
        style="background-image: url('/images/services/aplicacion-movil/compra-en-linea.webp')"
      >
        <div
          class="col-start-8 col-end-13 flex flex-col gap-2 justify-center xl:mt-6"
        >
          <h2 class="text-lg xl:text-4xl font-medium fs-condensed">
            Compra en Línea
          </h2>
          <p class="text-sm xl:text-lg fs-condensed">
            Puedes agregar tus cotizaciones y comprar en linea desde esta
            opción. Pagar y recoger en tienda o a domicilio.
          </p>
        </div>
      </article>
      <!-- Versión móvil -->
      <article
        class="xl:hidden flex flex-col justify-start gap-4 bg-cover bg-center bg-no-repeat h-[300px] p-6 pt-6"
        style="background-image: url('/images/services/aplicacion-movil/recompensas-allas-mobile.webp')"
      >
        <div class="w-full flex flex-col gap-2">
          <h3 class="text-3xl font-medium fs-condensed">
            Programa de Recompensas ALLAS
          </h3>
          <p class="text-lg fs-condensed">
            Afiliate Gratis desde la APP y comienza a disfrutar de las
            recompensas de la membresía.
          </p>
        </div>
      </article>
      <!-- Versión desktop -->
      <article
        class="hidden xl:flex flex-col justify-between gap-2 bg-cover bg-center bg-no-repeat h-[470px] xl:p-6"
        style="background-image: url('/images/services/aplicacion-movil/recompensas-allas.webp')"
      >
        <div class="w-full flex flex-col gap-2 items-center justify-center">
          <span class="flex flex-col gap-2">
            <h2 class="text-lg xl:text-4xl font-medium w-full fs-condensed">
              Programa de Recompensas ALLAS
            </h2>
            <p class="text-sm xl:text-lg w-full fs-condensed">
              Afiliate Gratis desde la APP y comienza a disfrutar de las <br />
              recompensas de la membresía.
            </p>
          </span>
        </div>
        <div class="w-full flex justify-end mb-12 mr-6">
          <button class="bg-black text-white font-light px-8 py-2 rounded-md">
            IR A RECOMPENSAS
          </button>
        </div>
      </article>
    </section>
  `,
})
export class PorqueUsarLaApp {}
